import { render } from "./Master.vue?vue&type=template&id=1b74c65b&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"

import "./Master.vue?vue&type=style&index=0&id=1b74c65b&scoped=true&lang=css"
import "./Master.vue?vue&type=style&index=1&id=1b74c65b&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b74c65b"]])

export default __exports__